module.exports = __webpack_public_path__ + "static/img/PK9.148f03a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK9.jpg
// module id = 3lNz
// module chunks = 0